/* eslint-disable camelcase */
import React, {ReactElement, useEffect, useState} from 'react';
import {
  Drawer,
  Radio,
  Divider,
  ListItemText,
  makeStyles,
  MenuItem,
  Select,
  Typography,
  Link,
  Tooltip,
  IconButton
} from '@material-ui/core';
import {CloseSharp} from '@material-ui/icons';
import {useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';

// components
import CustomSelectField from '../../ClinicGroups/AddUser/CustomSelectField';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {textFieldStyles} from '../../Invoices/TableDataAndStyles';
import {APP, APP_PRIMARY_COLOR, LIGHT_BLACK_COLOR} from 'src/style/variable';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import theme from '../../../../../materialtheme';
import Button from '@material-ui/core/Button';
import './ClaimsAnalysisStyles.scss';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
import HelperUtils, {formatReasonLabel} from '@shared/utils/HelperUtils';

import AgGridTable from '@components/system/AgGridTable/AgGridTable';
import {useHistory, useLocation} from 'react-router-dom';
import FilterChipWrapperComponent from '@components/system/FilterChipWrapper/FilterChipWrapperComponent';
import FilterChipComponent from '@components/system/FilterDrawer/FilterChipComponent';
import ClaimDetails from '../ClaimDetails/ClaimDetails';
import {useForm} from 'react-hook-form';

import {
  ClaimDasboardStatusTypes,
  SendClaimEligibleStatuses,
  PharmacyClaimStatus,
  AppPermissions
} from '@shared/constants/Mapping';
import NavRoutes from 'src/constants/route/NavRoutes';
// import DateInputField from '@components/system/FormField/DateInputField';
import ButtonField from '@components/system/ButtonField/ButtonField';
import {useDispatch, useSelector} from 'react-redux';
import {_statementsSelectedClinic} from '@shared/store/actions/ClinicActions';
import {getAllClaims} from '@shared/services/ClaimsServices';
import IgnoreDialog from '../IgnoreDialog/IgnoreDialog';
import {
  CloseAndAdjustBalanceToPatientClaim,
  getClaimFailedReasons,
  MarkForSubmission,
  ReverseClaim
} from '@shared/services/VaccinesServicesClaims';
import {SendClaim} from '@shared/services/ClaimsServices';
import {Permission} from '@shared/services/PermissionService';
import Loader from '@components/framework/loader/Loader';
import MultiSelectDropDownComponent from '@components/system/MultiSelectDropdown/MultiSelectDropdown';
import ClearFiltersIcon from '@components/system/MyIcons/ClearFiltersIcon';
import {CancelTokenSource, axios} from '@shared/axios';
// import DateRangeFilterField from '@components/system/FormField/DateRangeFilterField/DateRangeFilterField';
import ReloadIcon from '@components/system/ReloadIcon/ReloadIcon';
import PharmacyClaimsDateRangeFilterField from '../PharmacyClaimsDateRangeFilterField/PharmacyClaimsDateRangeFilterField';
import PharmacyClaimsPatientSearchSidebar, {
  emptyPharmacyClaimsPatientSearchValues,
  PharmacyClaimsPatientSearchValues
} from '../PharmacyClaimsPatientSearchSidebar/PharmacyClaimsPatientSearchSidebar';
import {State} from '@shared/store/reducers/Index';
import {formatApiMessage} from '@shared/utils/formatApiMessage';

export const getStatusLabel = (statusValue: string): any => {
  const status = ClaimDasboardStatusTypes.find(
    item => item.value === statusValue
  );
  return status ? status.label : '-'; // Return '-' if not found
};
export const FilterClinicStyles = makeStyles(() => ({
  root: {
    width: '400px',
    '&:focus': {
      outline: 'none'
    }
  },
  ClinicFilterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  ClinicMenu: {
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  // actionButtons: {
  //   justifyContent: 'flex-end',
  //   display: 'flex'
  // },
  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  clearAll: {
    textTransform: 'capitalize',
    fontSize: '1rem'
  },
  // tableContainer: {
  //   margin: '0rem 2rem 0rem',
  //   display: 'flex',
  //   flexDirection: 'column',
  //   overflow: 'auto',
  //   boxShadow: '0 0 0 1px rgb(63 63 68 / 5%), 0 1px 3px 0 rgb(63 63 68 / 15%)'
  // },
  // emptyTableStyle: {
  //   height: '3rem',
  //   overflow: 'auto',
  //   textAlign: 'center'
  // },
  // close: {
  //   display: 'flex',
  //   justifyContent: 'flex-end',
  //   padding: '10px 16px',
  //   paddingTop: '16px'
  // },
  button: {
    fontFamily: APP.FONT_FAMILY.BOLD,
    height: '2.7rem',
    justifyContent: 'center',
    padding: 0,
    margin: '5px',
    '& .span': {
      padding: 0
    }
  },
  // paperHeading: {
  //   fontSize: '15rem',
  //   marginBottom: '12px'
  // },
  paper: {
    position: 'absolute',
    width: '30vw',
    minWidth: '400px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '5px',
    boxShadow: '0 5px 10px 0 rgb(0 0 0 / 11%)',
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    padding: theme.spacing(3, 4)
  },
  actionTypeDropdown: {
    width: '350px'
  },
  refresh: {
    paddingLeft: '1rem'
  },
  reloadIcon: {
    // .MuiIconButton-root
    '& .MuiIconButton-root': {
      padding: '0'
    }
  },
  LinkStyle: {
    cursor: 'pointer',
    color: APP_PRIMARY_COLOR,
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  DateField: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #c1c1c1',
      '&:hover': {
        border: '1px solid #c1c1c1'
      }
    }
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0.5rem',
    alignItems: 'baseline'
  },
  FilterChipWrapper: {
    margin: '0rem 2rem 0rem 2rem',
    marginBottom: '0.5rem',
    paddingBottom: '0.2rem',
    overflowX: 'auto',
    overflowY: 'hidden'
  },
  refreshButton: {
    color: LIGHT_BLACK_COLOR
  },
  FailureDropDownWarapper: {
    opacity: '0.6'
  }
}));

interface Balances {
  label: string;
  key: string;
  count: string;
  amount: number;
}

interface ByAgeKeys {
  min_age: number;
  max_age: number;
}

interface ByAgeState {
  keys: ByAgeKeys;
  label: string;
  pending: number;
  rejected: number;
}
interface ComponentStates {
  selectedReasons: any[];
  failureReasons: any[];
  byAgeState: ByAgeState;
  dateRangeSelectedLabelObject: {
    label: string;
    key: string;
  };
}

interface DashboardCardState {
  patientBalance: Balances | null; // Use the new interface
  adjustmentBalance: Balances; // Define this as needed
}

const PATIENT_SEARCH_QUERY_KEYS: Array<keyof PharmacyClaimsPatientSearchValues> = [
  'last_name',
  'first_name',
  'account_number',
  'guarantor_first_name',
  'guarantor_last_name',
  'date_of_service'
];

const ClaimsAnalysis = (props: any): ReactElement => {
  const classes = textFieldStyles();
  const ClinicClasses = FilterClinicStyles();
  const history = useHistory();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const clinicList: any = useSelector((state: any) => state.clinics.list || []);
  const acOfClinics: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );
  const groupId: any = useSelector((state: any) => state.auth.groupId);
  const userPermissions = useSelector(
    (state: State) => state.auth.userPermissions
  );
  const acOfClinicLabels: any = useSelector(
    (state: any) => state.clinics.selectedClinicLabel || []
  );
  const [forceUpdate, setForceUpdate] = useState(-1);
  const [dateValue, setDateValue] = useState(null);
  const [open, setOpen]: any = useState(false);
  const location = useLocation();
  const isAttentionClaimsTab = location.pathname.includes(
    `/${NavRoutes.PRIVATE.ADMIN.CLAIMS_NESTED.CLAIM_TODOS}`
  );
  const [loaderValue, setLoaderValue] = useState<any>({
    number: 0,
    name: ''
  });
  const [statusType, setStatusType]: any = useState(null);
  const [dashboardCard, setDashboardCard] = useState<DashboardCardState>({
    patientBalance: null,
    adjustmentBalance: null
  });

  const {patientBalance, adjustmentBalance} = dashboardCard;

  const [ignoreOpenDialog, setIgnoreOpenDialog] = useState<boolean>(false);
  const [sendClaimLoadingIds, setSendClaimLoadingIds] = useState<number[]>([]);
  const [isPatientSearchDrawerOpen, setIsPatientSearchDrawerOpen] =
    useState<boolean>(false);

  const findClaimStatusLabel = (value: any) => {
    const [item] = ClaimDasboardStatusTypes.filter(
      (status: any) => status.value === value
    );
    return item ? item?.label : '-';
  };
  const [statusTypeLabel, setStatusTypeLabel]: any = useState(
    statusType ? findClaimStatusLabel(statusType) : t('CLAIMS.CLAIM_STATUS')
  );

  const {enqueueSnackbar} = useSnackbar();

  // grid table ref
  const tableRef: any = React.useRef();
  const [claims, setClaims] = useState<any>([]);
  const [selectedClaim, setSelectedClaim] = useState<any>({});
  const [ignoreClaimId, setIgnoreClaimId] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  // const [loader, setLoader] = useState(false)
  const [filters, setFilters] = useState({
    last_name: '',
    first_name: '',
    account_number: '',
    guarantor_first_name: '',
    guarantor_last_name: '',
    date_of_service: '',
    date_of_service_min: '',
    date_of_service_max: '',
    date_of_service_label: ''
  });

  const {control, setValue, getValues} = useForm({
    mode: 'all'
  });
  const cancelSuccesiveApiCall = React.useRef<CancelTokenSource | null>(null);
  const prevClaimsPathRef = React.useRef(location.pathname);

  const [state, setState] = useState<ComponentStates>({
    selectedReasons: [],
    failureReasons: [],
    byAgeState: {
      keys: {
        min_age: null,
        max_age: null
      },
      label: '',
      pending: 0,
      rejected: 0
    },
    dateRangeSelectedLabelObject: {
      label: '',
      key: ''
    }
  });
  const {
    selectedReasons,
    failureReasons,
    byAgeState,
    dateRangeSelectedLabelObject
  } = state;

  const refreshGrid = async () => {
    await fetchClaimsData(groupId, acOfClinics, statusType); // Fetch new data
    if (tableRef.current) {
      tableRef.current.refreshGrid(); // Call the refresh method on AG Grid
    }
  };
  const fetchClaimsData = async (
    clinicGroupId: number,
    clinicId: number,
    status: string
  ): Promise<void> => {
    try {
      setLoading(true);
      const options: any = {};
      if (status) {
        options.status = status;
      }
      if (selectedReasons && selectedReasons.length > 0) {
        options.failed_reason = selectedReasons.join(','); // Join array into a string
      }
      if (dateValue) {
        options.date_of_service = dateValue;
      }
      if (byAgeState?.keys) {
        const {min_age, max_age} = byAgeState.keys;
        // Send only min_age if max_age is not defined
        if (min_age !== null && min_age !== undefined) {
          options.min_age = min_age;
        }
        if (max_age !== null && max_age !== undefined) {
          options.max_age = max_age;
        }
      }

      if (patientBalance) {
        options.patient_balance = patientBalance?.key;
      }
      if (adjustmentBalance) {
        options.adjustment_balance = adjustmentBalance?.key;
      }
      // Include additional filters from filters state
      if (Object.keys(filters).length > 0) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value && key !== 'date_of_service_label') {
            // Exclude date_of_service_label
            options[key] = value; // Add each filter to options if it has a value
          }
        });
      }
      const cancelTokenParam: any = (cancelSuccesiveApiCall.current = axios.CancelToken.source());
      const res: any = await getAllClaims(
        clinicGroupId,
        clinicId,
        options,
        cancelTokenParam
      );
      if (res) {
        setClaims(res?.data?.rows);
      } else {
        setClaims([]);
      }
      // return res;
    } catch (error) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const init = async (status: any) => {
    if (cancelSuccesiveApiCall.current) {
      cancelSuccesiveApiCall.current.cancel();
      // Make the cancelSuccesiveApiCall.current to null after cancelling the api call
      cancelSuccesiveApiCall.current = null;
    }
    await fetchClaimsData(groupId, acOfClinics, status);
  };

  const fetchClaimFailureReasons = async () => {
    try {
      const res: any = await getClaimFailedReasons(groupId, acOfClinics?.[0]);
      if (res) {
        if (res?.data?.length > 0) {
          const reasons = res.data.map((item: {failed_reason: any}) => ({
            failed_reason: item.failed_reason
          }));
          setState((p: any) => ({
            ...p,
            failureReasons: reasons
          }));
        } else {
          setState((p: any) => ({
            ...p,
            failureReasons: []
          }));
        }
      }
    } catch (err: any) {
      enqueueSnackbar(formatApiMessage(err), SnackBarConfig('e'));
    }
  };

  useEffect(() => {
    if (acOfClinics?.length > 0) {
      fetchClaimFailureReasons();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acOfClinics]);

  useEffect(() => {
    const prevPath = prevClaimsPathRef.current;
    prevClaimsPathRef.current = location.pathname;

    const claimTodosSegment = `/${NavRoutes.PRIVATE.ADMIN.CLAIMS_NESTED.CLAIM_TODOS}`;
    const claimsAnalysisSegment = `/${NavRoutes.PRIVATE.ADMIN.CLAIMS_NESTED.CLAIMS}`;

    const onAttentionTab = location.pathname.includes(claimTodosSegment);
    const wasAttentionTab = prevPath.includes(claimTodosSegment);
    const onClaimsAnalysisTab = location.pathname.includes(
      claimsAnalysisSegment
    );

    if (onAttentionTab) {
      setStatusType(PharmacyClaimStatus.ATTENTION);
      setStatusTypeLabel(findClaimStatusLabel(PharmacyClaimStatus.ATTENTION));
      return;
    }

    if (wasAttentionTab && onClaimsAnalysisTab) {
      setStatusType(null);
      setStatusTypeLabel(t('CLAIMS.CLAIM_STATUS'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (acOfClinics?.length > 0) {
      init(statusType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    acOfClinics,
    selectedReasons,
    forceUpdate,
    statusType,
    byAgeState,
    dateValue,
    adjustmentBalance,
    patientBalance,
    statusTypeLabel,
    filters
  ]);

  const syncPatientSearchToUrl = (
    patientValues: PharmacyClaimsPatientSearchValues
  ): void => {
    const params = new URLSearchParams(location.search);
    PATIENT_SEARCH_QUERY_KEYS.forEach(key => {
      const value = patientValues[key];
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    const search = params.toString();
    history.replace({
      pathname: location.pathname,
      search: search ? `?${search}` : ''
    });
  };

  const handlePatientSearchApply = (
    patientValues: PharmacyClaimsPatientSearchValues
  ): void => {
    setFilters(prev => ({
      ...prev,
      last_name: patientValues.last_name || '',
      first_name: patientValues.first_name || '',
      account_number: patientValues.account_number || '',
      guarantor_first_name: patientValues.guarantor_first_name || '',
      guarantor_last_name: patientValues.guarantor_last_name || '',
      date_of_service: patientValues.date_of_service || ''
    }));
    syncPatientSearchToUrl(patientValues);
    setIsPatientSearchDrawerOpen(false);
  };

  const handlePatientSearchClear = (): void => {
    setFilters(prev => ({
      ...prev,
      ...emptyPharmacyClaimsPatientSearchValues
    }));
    syncPatientSearchToUrl(emptyPharmacyClaimsPatientSearchValues);
    setIsPatientSearchDrawerOpen(false);
  };

  const patientSearchSidebarValues: PharmacyClaimsPatientSearchValues = {
    last_name: filters.last_name || '',
    first_name: filters.first_name || '',
    account_number: filters.account_number || '',
    guarantor_first_name: filters.guarantor_first_name || '',
    guarantor_last_name: filters.guarantor_last_name || '',
    date_of_service: filters.date_of_service || ''
  };

  const ResetFilters = (): void => {
    setDateValue(null);
    setState((p: any) => ({
      ...p,
      selectedReasons: [],
      byAgeState: {
        keys: {
          min_age: null,
          max_age: null
        },
        label: '',
        pending: 0,
        rejected: 0
      },
      dateRangeSelectedLabelObject: {
        label: '',
        key: ''
      }
    }));
    setFilters({
      last_name: '',
      first_name: '',
      account_number: '',
      guarantor_first_name: '',
      guarantor_last_name: '',
      date_of_service: '',
      date_of_service_min: '',
      date_of_service_max: '',
      date_of_service_label: ''
    });
    if (isAttentionClaimsTab) {
      setStatusType(PharmacyClaimStatus.ATTENTION);
      setStatusTypeLabel(findClaimStatusLabel(PharmacyClaimStatus.ATTENTION));
    } else {
      setStatusType(null);
      setStatusTypeLabel(t('CLAIMS.CLAIM_STATUS'));
    }
    setDashboardCard((p: any) => ({
      ...p,
      adjustmentBalance: null,
      patientBalance: null
    }));
    resetTheDateOfService();
    setForceUpdate(prev => prev + 1);
  };

  const renderStatusFilters = (): ReactElement | null => {
    if (isAttentionClaimsTab) {
      return null;
    }
    return (
      <div className="fields-margin filters-view">
        <Select
          value={statusTypeLabel}
          variant="outlined"
          // onChange={handleChangeStatementType}
          fullWidth={true}
          input={<CustomSelectField />}
          style={statusType ? {} : {opacity: 0.5}}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView select-action"
          disabled={!acOfClinics?.length}>
          <div
            className={[
              ClinicClasses.root,
              ClinicClasses.actionTypeDropdown
            ].join(' ')}>
            <div className={ClinicClasses.ClinicFilterHeader}>
              <Typography style={{fontSize: '1.3rem', margin: '0.6rem 0'}}>
                {t('CLAIMS.CLAIM_STATUS')}
              </Typography>
              <Button
                className={ClinicClasses.clearAll}
                onClick={(): void => {
                  setStatusType('');
                  setStatusTypeLabel(t('CLAIMS.CLAIM_STATUS'));
                  init('');
                }}>
                {t('COMMON.CLEAR_ALL')}
              </Button>
            </div>
            <Divider />
            <div className={ClinicClasses.ClinicMenu}>
              {ClaimDasboardStatusTypes.map((action: any) => {
                return (
                  <MenuItem
                    onClick={() => {
                      setStatusType(action.value);
                      setStatusTypeLabel(action.label);
                      init(action.value);
                    }}
                    key={action.value}
                    value={action.label}>
                    <ListItemText
                      className={[
                        ClinicClasses.secondary,
                        ClinicClasses.primary
                      ].join(' ')}
                      primary={action.label}
                    />
                    <Radio checked={statusType === action.value} />
                  </MenuItem>
                );
              })}
            </div>
          </div>
        </Select>
      </div>
    );
  };

  const selectClinic = (option: any) => {
    dispatch(
      _statementsSelectedClinic(
        [option.id],
        [option.name],
        option?.zone,
        option?.emr_provider
      )
    );
  };
  const clearClinicFilter = () => {
    dispatch(_statementsSelectedClinic([], [], '', ''));
    // TODO: NEED TO CLEAR ALL THE FILTER
    refreshGrid();
    setClaims([]);
    ResetFilters();
  };
  const renderClinicFilters = (): ReactElement => {
    return (
      <div style={{minWidth: '230px'}}>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          // value={acOfClinics.length ? acOfClinicLabels : ['Select clinic']}
          value={
            acOfClinics.length
              ? acOfClinicLabels
              : [t('PATIENTS.SELECT_CLINIC')]
          }
          variant="outlined"
          // onChange={handleAccessOfClinics}
          fullWidth={true}
          style={acOfClinics.length ? {} : {opacity: 0.5}}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView">
          <div className={ClinicClasses.root}>
            <div className={ClinicClasses.ClinicFilterHeader}>
              <Typography style={{fontSize: '1.3rem'}}>
                {t('PATIENTS.CLINICS')}
              </Typography>
              <Button
                className={ClinicClasses.clearAll}
                onClick={clearClinicFilter}>
                {t('COMMON.CLEAR_ALL')}
              </Button>
            </div>
            <Divider />
            <div className={ClinicClasses.ClinicMenu}>
              {clinicList.map((clinic: any) => (
                <MenuItem
                  key={clinic.id}
                  value={clinic.name}
                  onClick={(): void => {
                    selectClinic(clinic);
                  }}>
                  <ListItemText
                    className={[
                      ClinicClasses.secondary,
                      ClinicClasses.primary
                    ].join(' ')}
                    primary={clinic.name}
                    secondary={`${clinic.city}, ${clinic.country}`}
                  />
                  <Radio checked={acOfClinics.indexOf(clinic.id) > -1} />
                </MenuItem>
              ))}
            </div>
          </div>
        </Select>
      </div>
    );
  };

  const handleReSubmission = async (submittingData: any) => {
    try {
      setLoaderValue((p: any) => ({
        ...p,
        number: submittingData.id,
        name: t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.MARK_FOR_RE_SUBMISSION')
      }));
      const res = await MarkForSubmission(
        groupId,
        acOfClinics?.[0],
        submittingData?.id
      );
      if (res) {
        setForceUpdate(forceUpdate + 1);
        enqueueSnackbar(
          formatApiMessage(res?.message ?? res),
          SnackBarConfig('s')
        );
      }
    } catch (err: any) {
      enqueueSnackbar(formatApiMessage(err), SnackBarConfig('e'));
    } finally {
      setLoaderValue((P: any) => ({
        ...P,
        number: 0,
        name: ''
      }));
    }
  };

  const handleSendClaim = async (claimData: any) => {
    try {
      setSendClaimLoadingIds(prev => [...prev, claimData.id]);
      const res = await SendClaim(groupId, acOfClinics?.[0], claimData?.id);
      if (res) {
        setForceUpdate(forceUpdate + 1);
        enqueueSnackbar(
          formatApiMessage(res?.message ?? res),
          SnackBarConfig('s')
        );
      }
    } catch (err: any) {
      enqueueSnackbar(formatApiMessage(err), SnackBarConfig('e'));
    } finally {
      setSendClaimLoadingIds(prev => prev.filter(id => id !== claimData.id));
    }
  };

  const handleReverseClaim = async (ReverseClaimData: any) => {
    try {
      const res = await ReverseClaim(
        groupId,
        acOfClinics?.[0],
        ReverseClaimData?.id
      );
      if (res) {
        setForceUpdate(forceUpdate + 1);
        enqueueSnackbar(
          formatApiMessage(res?.message ?? res),
          SnackBarConfig('s')
        );
      }
    } catch (err: any) {
      enqueueSnackbar(formatApiMessage(err), SnackBarConfig('e'));
    } finally {
      setLoaderValue((P: any) => ({
        ...P,
        number: 0,
        name: ''
      }));
    }
  };

  const handleCloseClaim = async (CloseClaimData: any, type: string) => {
    try {
      const params: any = {};
      if (type) {
        params.type = type;
      }
      const res = await CloseAndAdjustBalanceToPatientClaim(
        groupId,
        acOfClinics?.[0],
        CloseClaimData?.id,
        params
      );
      if (res) {
        setForceUpdate(forceUpdate + 1);
        enqueueSnackbar(
          formatApiMessage(res?.message ?? res),
          SnackBarConfig('s')
        );
      }
    } catch (err: any) {
      enqueueSnackbar(formatApiMessage(err), SnackBarConfig('e'));
    } finally {
      setLoaderValue((P: any) => ({
        ...P,
        number: 0,
        name: ''
      }));
    }
  };

  const renderLoader = () => {
    return <Loader size={16} />;
  };

  const claimsColumns: any = [
    {
      headerName: t('CLAIMS.CLAIM_NO'),
      field: 'prescription_reference_number',
      flex: 1,
      minWidth: 126,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => {
        return (
          <div
            className={[
              classes.primaryTextColor,
              classes.patientNameStyles
            ].join(' ')}
            onClick={() => {
              setSelectedClaim(rowData.data);
              setOpen(true);
            }}
            style={{textAlign: 'center'}}>
            {rowData.data?.prescription_reference_number || '-'}
          </div>
        );
      }
    },
    {
      headerName: t('CLAIMS.PATIENT_NAME'),
      field: 'patient_name',
      flex: 1,
      minWidth: 150,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => (
        <div>
          {HelperUtils.formFullName(
            rowData.data?.patient?.first_name,
            rowData.data?.patient?.last_name,
            rowData.data?.patient?.middle_name
          ) || '-'}
        </div>
      )
    },
    {
      headerName: t('CLAIMS.PATIENT_ACCOUNT_NO'),
      field: 'account_number',
      flex: 1,
      minWidth: 160,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => (
        <div>{rowData?.data?.patient?.emr_id || '-'}</div>
      )
    },
    {
      headerName: t('CLAIMS.DATE_OF_SERVICE'),
      field: 'date_of_service',
      flex: 1,
      minWidth: 130,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => (
        <div>
          {HelperUtils.formatDisplayDate(rowData?.data?.date_of_service)}
        </div>
      )
    },
    {
      headerName: t('CLAIMS.CHARGES'),
      field: 'total_charges',
      flex: 1,
      minWidth: 100,
      cellClass: 'right-align',
      cellRenderer: (rowData: any) => {
        return (
          <div>
            <CurrencyFormatter
              value={rowData?.data?.total_claim_amount || '-'}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              ignoreRound={true}
              useSign={true}
            />
          </div>
        );
      }
    },
    {
      headerName: t('CLAIMS.BALANCE'),
      field: 'balance_amount',
      flex: 1,
      minWidth: 100,
      cellClass: 'right-align',
      cellRenderer: (rowData: any) => {
        return (
          <div>
            <CurrencyFormatter
              value={rowData?.data?.balance_amount || '0'}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              ignoreRound={true}
              useSign={true}
            />
          </div>
        );
      }
    },
    {
      headerName: t('CLAIMS.ADJUSTED_BALANCE'),
      field: 'adjusted_balance',
      flex: 1,
      minWidth: 150,
      cellClass: 'right-align',
      cellRenderer: (rowData: any) => {
        return (
          <div>
            <CurrencyFormatter
              value={rowData?.data?.adjustment_amount || '0'}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              ignoreRound={true}
              useSign={true}
            />
          </div>
        );
      }
    },
    {
      headerName: 'Paid Amount',
      field: 'paid_amount',
      flex: 1,
      minWidth: 140,
      cellClass: 'right-align',
      cellRenderer: (rowData: any) => {
        return (
          <CurrencyFormatter
            value={rowData?.data?.total_amount_paid || '-'}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            ignoreRound={true}
            useSign={true}
          />
        );
      }
    },
    {
      headerName: 'Patient Balance',
      field: 'patient_balance',
      flex: 1,
      minWidth: 140,
      cellClass: 'right-align',
      cellRenderer: (rowData: any) => {
        return (
          <CurrencyFormatter
            value={rowData?.data?.patient_pay_amount || '-'}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            ignoreRound={true}
            useSign={true}
          />
        );
      }
    },
    {
      headerName: t('CLAIMS.STATUS'),
      field: 'status',
      flex: 1,
      minWidth: 170,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => {
        return <div>{getStatusLabel(rowData?.data?.status) || '-'}</div>;
      }
    },
    {
      headerName: t('CLAIMS.PAID_DATE'),
      field: 'paid_date',
      flex: 1,
      minWidth: 130,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => (
        <div>
          {HelperUtils.formatDisplayDate(rowData?.data?.paid_date) || '-'}
        </div>
      )
    },
    {
      headerName: t('Failure Reason'),
      field: 'failure_reason',
      flex: 1,
      minWidth: 270,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => {
        return <div>{rowData?.data?.failed_reason || '-'}</div>;
      }
    },
    {
      headerName: t('CLAIMS.BLOCKING_REASONS'),
      field: 'blocking_reasons',
      flex: 1,
      minWidth: 220,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => {
        const br = formatReasonLabel(rowData?.data?.blocking_reasons);
        return (
          <div>
            {br != null && br !== ''
              ? typeof br === 'string'
                ? br
                : String(br)
              : '-'}
          </div>
        );
      }
    },
    {
      headerName: t('Actions'),
      field: 'action',
      flex: 1,
      minWidth: 180,
      cellClass: 'left-align',
      cellRenderer: (rowData: any) => {
        const actionLinks: React.ReactNode[] = [];
        const status = rowData?.data?.status;
        const claimId = rowData?.data?.id;

        // Rejected status actions
        if (status === PharmacyClaimStatus.REJECTED) {
          actionLinks.push(
            <Link
              key="mark-resubmission"
              style={{padding: '0.2rem'}}
              component="button"
              onClick={() => {
                handleReSubmission(rowData?.data);
              }}>
              {loaderValue.name ===
                t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.MARK_FOR_RE_SUBMISSION') &&
              loaderValue.number === claimId
                ? renderLoader()
                : t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.MARK_FOR_RE_SUBMISSION')}
            </Link>
          );
          actionLinks.push(
            <Link
              key="ignore"
              style={{padding: '0.2rem'}}
              component="button"
              onClick={() => {
                setLoaderValue((p: any) => ({
                  ...p,
                  number: claimId,
                  name: t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.IGNORE')
                }));
                setIgnoreClaimId(claimId);
                setIgnoreOpenDialog(true);
              }}>
              {loaderValue.name === t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.IGNORE') &&
              loaderValue.number === claimId
                ? renderLoader()
                : t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.IGNORE')}
            </Link>
          );
        }

        // Paid status actions
        if (status === PharmacyClaimStatus.PAID) {
          actionLinks.push(
            <Link
              key="close"
              style={{padding: '0.2rem'}}
              component="button"
              onClick={() => {
                setLoaderValue((p: any) => ({
                  ...p,
                  number: claimId,
                  name: t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.CLOSE_CLAIM')
                }));
                handleCloseClaim(rowData?.data, 'closed');
              }}>
              {loaderValue.name ===
                t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.CLOSE_CLAIM') &&
              loaderValue.number === claimId
                ? renderLoader()
                : t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.CLOSE_CLAIM')}
            </Link>
          );
          actionLinks.push(
            <Link
              key="reverse"
              style={{padding: '0.2rem'}}
              component="button"
              onClick={() => {
                setLoaderValue((p: any) => ({
                  ...p,
                  number: claimId,
                  name: t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.REVERSE_CLAIM')
                }));
                handleReverseClaim(rowData?.data);
              }}>
              {loaderValue.name ===
                t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.REVERSE_CLAIM') &&
              loaderValue.number === claimId
                ? renderLoader()
                : t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.REVERSE_CLAIM')}
            </Link>
          );
          actionLinks.push(
            <Link
              key="adjust-close"
              style={{padding: '0.2rem'}}
              component="button"
              onClick={() => {
                setLoaderValue((p: any) => ({
                  ...p,
                  number: claimId,
                  name: t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADJUST_CLOSE')
                }));
                handleCloseClaim(rowData?.data, 'adjusted_and_closed');
              }}>
              {loaderValue.name ===
                t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADJUST_CLOSE') &&
              loaderValue.number === claimId
                ? renderLoader()
                : t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADJUST_CLOSE')}
            </Link>
          );
          actionLinks.push(
            <Link
              key="adjust-patient-balance"
              style={{padding: '0.2rem'}}
              component="button"
              onClick={() => {
                setLoaderValue((p: any) => ({
                  ...p,
                  number: claimId,
                  name: t(
                    'CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADJUST_TO_PATIENT_BALANCE'
                  )
                }));
                handleCloseClaim(rowData?.data, 'adjust_patient_balance');
              }}>
              {loaderValue.name ===
                t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADJUST_TO_PATIENT_BALANCE') &&
              loaderValue.number === claimId
                ? renderLoader()
                : t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADJUST_TO_PATIENT_BALANCE')}
            </Link>
          );
          actionLinks.push(
            <Link
              key="add-balance-close"
              style={{padding: '0.2rem'}}
              component="button"
              onClick={() => {
                setLoaderValue((p: any) => ({
                  ...p,
                  number: claimId,
                  name: t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADD_BALANCE_AND_CLOSE')
                }));
                handleCloseClaim(rowData?.data, 'added_to_patient_balance');
              }}>
              {loaderValue.name ===
                t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADD_BALANCE_AND_CLOSE') &&
              loaderValue.number === claimId
                ? renderLoader()
                : t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.ADD_BALANCE_AND_CLOSE')}
            </Link>
          );
        }

        // Send Claim action for eligible statuses
        if (
          SendClaimEligibleStatuses.includes(status) &&
          Permission.hasPharmacyClaimPermissions(
            userPermissions,
            AppPermissions.CLAIM.SEND_CLAIM,
            groupId
          )
        ) {
          actionLinks.push(
            <Link
              key="send-claim"
              style={{padding: '0.2rem'}}
              component="button"
              onClick={() => {
                handleSendClaim(rowData?.data);
              }}>
              {sendClaimLoadingIds.includes(claimId)
                ? renderLoader()
                : t('CLAIMS.CLAIM_ANALYSIS.ACTIONS.SEND_CLAIM')}
            </Link>
          );
        }

        return (
          <div className={ClinicClasses.actions}>
            {actionLinks.length > 0 ? actionLinks : '-'}
          </div>
        );
      }
    }
  ];

  const resetTheDateOfService = () => {
    setValue('date_of_service_min', null);
    setValue('date_of_service_max', null);
  };
  const renderDateRangeFilter = () => {
    return (
      <div className="date-range-filter">
        <PharmacyClaimsDateRangeFilterField
          key={forceUpdate}
          // label="Date Of Service"
          fromFiled={{
            name: 'date_of_service_min',
            placeholder: t('Min date of service')
          }}
          toField={{
            name: 'date_of_service_max',
            placeholder: t('Max date of service')
          }}
          control={control}
          getValues={getValues}
          defaultSelectedRangeKey={dateRangeSelectedLabelObject?.key || ''} // Pass the default selected label
          onUpdateDateRange={({from, to}, itemObject: any) => {
            setValue('date_of_service_min', from);
            setValue('date_of_service_max', to);
            setFilters((prev: any) => ({
              ...prev,
              date_of_service_min: from,
              date_of_service_max: to,
              date_of_service_label: itemObject?.label
            }));
            setState((prev: any) => ({
              ...prev,
              dateRangeSelectedLabelObject: {
                label: itemObject?.label,
                key: itemObject?.key
              }
            }));
          }}
        />
      </div>
    );
  };

  const renderResetFilter = (): ReactElement => {
    return (
      <div className="fields-margin">
        <ButtonField
          data-test-id="pcl-claims-scree-reset"
          onClick={(): void => ResetFilters()}
          buttonText={t('Reset')}
          className={[
            classes.buttonStyle,
            classes.resetButtonStyles
            // ClinicClasses.lineHeight
          ].join(' ')}
          // disabled={!acOfClinics?.length}
        />
      </div>
    );
  };

  // // rendering the IgnoreDialog
  const renderIgnoreDialog = () => {
    return (
      <IgnoreDialog
        open={ignoreOpenDialog}
        claimId={ignoreClaimId}
        onClose={res => {
          if (res === 'confirm') {
            setIgnoreOpenDialog(false);
            setIgnoreClaimId({});
            init(statusType);
            setLoaderValue((p: any) => ({
              ...p,
              number: 0,
              name: ''
            }));
          } else {
            setIgnoreOpenDialog(false);
            setIgnoreClaimId({});
            setLoaderValue((p: any) => ({
              ...p,
              number: 0,
              name: ''
            }));
          }
        }}
      />
    );
  };

  // ** reading queryParams FromUrl and applying the filter chips accordingly --> start */
  useEffect(() => {
    const getQueryParams = () => {
      return new URLSearchParams(location.search);
    };
    const failedReasonString = getQueryParams().get('failed_reason');
    const byAgeString = getQueryParams().get('by_age');
    const statusString = getQueryParams().get('status');
    const minimumDateOfService = getQueryParams().get('date_of_service_min');
    const maximumDateOfService = getQueryParams().get('date_of_service_max');
    const labelObject: any = getQueryParams().get('date_range_label');

    if (failedReasonString) {
      try {
        const reasons = JSON.parse(decodeURIComponent(failedReasonString));
        if (reasons) {
          setState((p: any) => ({
            ...p,
            selectedReasons: [reasons?.failed_reason]
          }));
        }
      } catch (err: any) {
        enqueueSnackbar(formatApiMessage(err), SnackBarConfig('e'));
      }
    }

    if (byAgeString) {
      try {
        const byAge = JSON.parse(decodeURIComponent(byAgeString));
        setState(prevState => ({
          ...prevState,
          byAgeState: {
            ...prevState.byAgeState,
            ...byAge
          }
        }));
      } catch (err: any) {
        enqueueSnackbar(formatApiMessage(err), SnackBarConfig('e'));
      }
    }

    if (statusString) {
      try {
        const status = JSON.parse(decodeURIComponent(statusString));

        if (status?.key === 'patient_balance') {
          setDashboardCard((p: any) => ({
            ...p,
            patientBalance: status
          }));
        } else if (status?.key === 'adjustment_balance') {
          setDashboardCard((p: any) => ({
            ...p,
            adjustmentBalance: status
          }));
        } else if (
          !location.pathname.includes(
            `/${NavRoutes.PRIVATE.ADMIN.CLAIMS_NESTED.CLAIM_TODOS}`
          )
        ) {
          setStatusType(status.key);
          setStatusTypeLabel(findClaimStatusLabel(status.key));
          setForceUpdate(forceUpdate + 1);
        }
      } catch (err: any) {
        enqueueSnackbar(formatApiMessage(err), SnackBarConfig('e'));
      }
    }
    // ** NOte: for every card status and also the failure reason i need to send this date of service to the  API
    if (minimumDateOfService && maximumDateOfService && labelObject) {
      const parsedlabelObject: any = JSON.parse(
        decodeURIComponent(labelObject)
      );
      setFilters((prev: any) => ({
        ...prev,
        date_of_service_min: minimumDateOfService,
        date_of_service_max: maximumDateOfService,
        date_of_service_label: parsedlabelObject?.label
      }));
      setValue('date_of_service_min', minimumDateOfService);
      setValue('date_of_service_max', maximumDateOfService);
      setState((prev: any) => ({
        ...prev,
        dateRangeSelectedLabelObject: {
          label: parsedlabelObject?.label,
          key: parsedlabelObject?.key
        }
      }));
    }

    // * patient search functionality reading the names fromUrl ---> START
    const queryParams = getQueryParams();
    // Extracting filters from query parameters
    const lastNameParam: string = queryParams.get('last_name');
    const firstNameParam: string = queryParams.get('first_name');
    const accountNumberParam: string = queryParams.get('account_number');
    const guarantorFirstNameParam: string = queryParams.get(
      'guarantor_first_name'
    );
    const guarantorLastNameParam: string = queryParams.get(
      'guarantor_last_name'
    );
    const fromParam: any = queryParams.get('from');
    const dateOfServiceParam: string | null = queryParams.get('date_of_service');
    // Set state with extracted parameters
    setFilters((prev: any) => ({
      ...prev,
      last_name: lastNameParam || '',
      first_name: firstNameParam || '',
      account_number: accountNumberParam || '',
      guarantor_first_name: guarantorFirstNameParam || '',
      guarantor_last_name: guarantorLastNameParam || '',
      date_of_service: dateOfServiceParam || fromParam || ''
    }));

    // * patient search functionality reading the names fromUrl ---> END
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]); // Re-run when location changes

  // ** reading Query Parms fromUrl ---> End */

  // ** render the failure dropdown */
  const handleItemChange = (event: any, clinic: any) => {
    // handler for item change
  };
  const onClickCalled = (event: any, clinic: any) => {
    // set selected reason
    const reasons = [...selectedReasons];
    if (reasons.indexOf(clinic.failed_reason) > -1) {
      reasons.splice(reasons.indexOf(clinic.failed_reason), 1);
    } else {
      reasons.push(clinic.failed_reason);
    }
    setState((p: any) => ({
      ...p,
      selectedReasons: reasons
    }));
    // resetPagesInGrid();
    // refreshGrid();
  };

  const clearReasonsFilter = () => {
    setState((p: any) => ({
      ...p,
      selectedReasons: []
    }));
    // resetPagesInGrid();
  };

  const clearFailureReason = (item: any) => {
    const reasons = [...selectedReasons];
    if (reasons.indexOf(item) > -1) {
      reasons.splice(reasons.indexOf(item), 1);
    }
    setState((p: any) => ({
      ...p,
      selectedReasons: reasons
    }));
    // resetPagesInGrid();
  };

  const renderFailureReasonsFilters = (): ReactElement => {
    return (
      <div
        className={
          !selectedReasons?.length ? ClinicClasses.FailureDropDownWarapper : ''
        }>
        <MultiSelectDropDownComponent
          selectedValues={selectedReasons}
          data={failureReasons}
          onClickCalled={(event: any, clinic: any) => {
            onClickCalled(event, clinic);
          }}
          handleItemChange={(event: any, clinic: any) => {
            handleItemChange(event, clinic);
          }}
          clearFilter={() => {
            clearReasonsFilter();
          }}
          primaryLabel={
            selectedReasons.length
              ? selectedReasons
              : [t('NOTIFICATIONS_HISTORY.FILTER_BY_FAILED_REASONS')]
          }
          headerLabel={t('NOTIFICATIONS_HISTORY.FAILED_REASONS')}
          objKey={'failed_reason'}
          disabled={!acOfClinics?.length}
        />
      </div>
    );
  };

  const renderFilterChips = () => {
    return (
      <FilterChipWrapperComponent>
        {statusType?.length > 0 &&
          acOfClinics?.length > 0 &&
          !isAttentionClaimsTab && (
            <FilterChipComponent
              value={statusTypeLabel}
              onRemove={() => {
                setStatusType('');
                setStatusTypeLabel(t('CLAIMS.CLAIM_STATUS'));
              }}
            />
          )}
        {patientBalance && acOfClinics?.length > 0 && (
          <FilterChipComponent
            value={patientBalance?.label}
            onRemove={() => {
              setDashboardCard((p: any) => ({
                ...p,
                patientBalance: null
              }));
            }}
          />
        )}
        {adjustmentBalance && acOfClinics?.length > 0 && (
          <FilterChipComponent
            value={adjustmentBalance?.label}
            onRemove={() => {
              setDashboardCard((p: any) => ({
                ...p,
                adjustmentBalance: null
              }));
            }}
          />
        )}
        {dateValue && (
          <FilterChipComponent
            value={`Date of Service : ${dateValue}`}
            onRemove={() => setDateValue(null)}
          />
        )}
        {selectedReasons &&
          acOfClinics.length > 0 &&
          selectedReasons.length > 0 &&
          selectedReasons.map((reason: any, i: any) => {
            return (
              <span key={reason} className={'second-rows-labels'}>
                <FilterChipComponent
                  value={`${reason}`}
                  onRemove={(): void => {
                    clearFailureReason(reason);
                  }}
                />
              </span>
            );
          })}
        {byAgeState?.keys?.min_age !== null &&
          byAgeState?.keys?.max_age !== null && (
            <FilterChipComponent
              value={`All Claims By Age: ${byAgeState?.label}`}
              onRemove={() => {
                setState((p: any) => ({
                  ...p,
                  byAgeState: {
                    keys: {
                      min_age: null,
                      max_age: null
                    },
                    label: '',
                    pending: 0,
                    rejected: 0
                  }
                }));
              }}
            />
          )}
        {filters.last_name && (
          <FilterChipComponent
            value={`Last Name: ${filters.last_name}`}
            onRemove={() => {
              setFilters(prev => ({...prev, last_name: ''}));
            }}
          />
        )}
        {filters.first_name && (
          <FilterChipComponent
            value={`First Name: ${filters.first_name}`}
            onRemove={() => {
              setFilters(prev => ({...prev, first_name: ''}));
            }}
          />
        )}
        {filters.account_number && (
          <FilterChipComponent
            value={`Account Number: ${filters.account_number}`}
            onRemove={() => {
              setFilters(prev => ({...prev, account_number: ''}));
            }}
          />
        )}
        {filters.guarantor_first_name && (
          <FilterChipComponent
            value={`Guarantor First Name: ${filters.guarantor_first_name}`}
            onRemove={() => {
              setFilters(prev => ({...prev, guarantor_first_name: ''}));
            }}
          />
        )}
        {filters.guarantor_last_name && (
          <FilterChipComponent
            value={`Guarantor Last Name: ${filters.guarantor_last_name}`}
            onRemove={() => {
              setFilters(prev => ({...prev, guarantor_last_name: ''}));
            }}
          />
        )}
        {filters.date_of_service && (
          <FilterChipComponent
            value={`Date of Service: ${filters.date_of_service}`}
            onRemove={() => {
              setFilters(prev => ({...prev, date_of_service: ''}));
            }}
          />
        )}
        {filters?.date_of_service_max &&
          filters?.date_of_service_min &&
          filters?.date_of_service_label &&
          dateRangeSelectedLabelObject?.key && (
            <FilterChipComponent
              value={`Date of Service : ${filters?.date_of_service_min} - ${filters?.date_of_service_max}`}
              onRemove={() => {
                // ** make the filter chips state empty and also the setValue of the date input fields also
                setFilters(prev => ({
                  ...prev,
                  date_of_service_min: '',
                  date_of_service_max: '',
                  date_of_service_label: ''
                }));
                setState((prev: any) => ({
                  ...prev,
                  dateRangeSelectedLabelObject: {
                    label: '',
                    key: ''
                  }
                }));
                resetTheDateOfService();
                setForceUpdate(prev => prev + 1);
              }}
            />
          )}
        {((isAttentionClaimsTab ? false : statusType) ||
          selectedReasons.length > 0 ||
          dateValue ||
          (byAgeState?.keys?.min_age !== null &&
            byAgeState?.keys?.max_age !== null) ||
          Object.values(filters).some(value => value !== '') ||
          adjustmentBalance ||
          patientBalance ||
          (filters?.date_of_service_max &&
            filters?.date_of_service_min &&
            filters?.date_of_service_label &&
            dateRangeSelectedLabelObject?.key)) && (
          <span className={'second-rows-labels'}>
            <Tooltip title={t('CLAIMS.CLAIM_ANALYSIS.RESET_FILTERS_TOOLTIP')}>
              <IconButton
                aria-label={t('CLAIMS.CLAIM_ANALYSIS.RESET_FILTERS_TOOLTIP')}
                className={ClinicClasses.refreshButton}
                onClick={(): void => {
                  ResetFilters();
                }}>
                <ClearFiltersIcon />
              </IconButton>
            </Tooltip>
          </span>
        )}
      </FilterChipWrapperComponent>
    );
  };

  const renderRefreshButton = () => {
    return (
      <div className={ClinicClasses.reloadIcon}>
        <ReloadIcon
          title={t('DUE_INVOICES.REFRESH_DATA')}
          onClick={() => {
            // resetPagesInGrid()
            refreshGrid();
          }}
          disabled={!acOfClinics.length}
          fontSize="large"
          dataTestId="pcl-pharmacy-claims-refreshGrid"
        />
      </div>
    );
  };

  return (
    <div className={['claims-analysis-wrapper', classes.gridWrapper].join(' ')}>
      <div className={'search-filters-main-view'}>
        <div className="search-filters-child">
          {renderClinicFilters()}
          {renderStatusFilters()}
          {renderFailureReasonsFilters()}
          {acOfClinics?.length > 0 && renderDateRangeFilter()}
          {renderResetFilter()}
          {renderRefreshButton()}
        </div>
        <div>
          <Link
            color="primary"
            onClick={() => setIsPatientSearchDrawerOpen(true)}>
            {t('CLAIMS.CLAIMS_SEARCH_CRITERIA')}
          </Link>
        </div>
      </div>
      <div className={ClinicClasses.FilterChipWrapper}>{renderFilterChips()}</div>
      {loading ? (
        <div className="loader-styles">
          <Loader />
        </div>
      ) : (
        <div
          style={{
            height: 'calc(100% - 10rem)',
            padding: '0 2rem'
          }}>
          <AgGridTable data={claims} columns={claimsColumns} />
        </div>
      )}

      <Drawer
        disableEnforceFocus
        anchor="right"
        open={isPatientSearchDrawerOpen}
        onClose={() => setIsPatientSearchDrawerOpen(false)}>
        <div style={{width: 360, height: '100%', display: 'flex', flexDirection: 'column'}}>
          <div
            style={{
              padding: '10px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '1px solid #e0e0e0'
            }}>
            <Typography variant="h3">{t('CLAIMS.CLAIMS_SEARCH_CRITERIA')}</Typography>
            <IconButton onClick={() => setIsPatientSearchDrawerOpen(false)}>
              <CloseSharp className={'close-icon'} />
            </IconButton>
          </div>
          <div style={{padding: '15px 20px', overflow: 'auto', height: '100%'}}>
            <PharmacyClaimsPatientSearchSidebar
              values={patientSearchSidebarValues}
              onApply={handlePatientSearchApply}
              onClear={handlePatientSearchClear}
              disabled={!acOfClinics?.length}
            />
          </div>
        </div>
      </Drawer>

      {open && (
        <ClaimDetails
          open={open}
          claim={selectedClaim}
          handleClose={() => {
            setOpen(false);
            setSelectedClaim(null);
          }}
          onReSubmit={(data: any) => handleReSubmission(data)} // Pass function to mark for resubmission
          loader={loaderValue}
          setLoader={setLoaderValue}
          IgnoreFn={(claimId: number, value: boolean) => {
            setIgnoreClaimId(claimId);
            setIgnoreOpenDialog(value);
          }}
          // onIgnore={handleIgnoreClaim} // Pass function to ignore claim
        />
      )}
      {ignoreOpenDialog && renderIgnoreDialog()}
    </div>
  );
};

export default ClaimsAnalysis;
